import store from '../store'


function hasPermission (permission) {

    if (!permission) {
        return true;
    }

    var allowed = false;

    store.getters.getUserPermissions.forEach(userPermission => {
        if (userPermission.permission == 'ADMIN' || userPermission.permission == permission) {
            allowed = true;
        }
    });
    return allowed;
}

export {hasPermission}

